import { render, staticRenderFns } from "./KabBiakNumfor.vue?vue&type=template&id=0aadf31b"
import script from "./KabBiakNumfor.vue?vue&type=script&lang=js"
export * from "./KabBiakNumfor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports